import { BehaviorSubject, Observable } from 'rxjs';
import { IClearContext } from '../interface/iclear-context.interface';

export abstract class ContextBase<T> implements IClearContext {
  private readonly _contextChanged$: BehaviorSubject<T | null> = new BehaviorSubject<T | null>(null);
  public contextChanged$ = this._contextChanged$.asObservable();

  constructor() {}

  //#region Behavior

  /**
   * Get the context to use
   */
  get context(): T | null {
    return this._contextChanged$.getValue();
  }

  /**
   * Set the context to use
   */
  setContext(context: T): void {
    this._contextChanged$.next(context);
  }

  /**
   * Clean the context after detroy component
   */
  clear(): void {
    this._contextChanged$.next(null);
  }

  //#endregion
}
